<template>
    <div class="actions relative d-flex justify-content-end align-items-center">
        <div v-click-outside="close" @click="toggle($event)" class="px-4 pointer">
            <div v-if="!overrideVisible" class="bullets">
                <span></span>
            </div>

            <ul v-if="isVisible || overrideVisible" class="bg-lightest d-flex" :class="{'mr-4 position-absolute': !overrideVisible}">
                <li @click="buttonClick($event, action)" v-for="action in actions.list" :class="[action.class, 'medium']" :title="action.tooltip ? action.tooltip : action.title">
                    <i :class="[action.icon, 'pointer', 'px-1']"></i>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        row: Object,
        actions: Object, // alwaysVisible: true,
    },
    data: function () {
        return {
            isVisible: false
        }
    },
    computed: {
        overrideVisible: function () {
            return this.actions.alwaysVisible && this.actions.alwaysVisible == true
        }
    },
    methods: {
        toggle: function (event) {
            if (event) {
                event.stopPropagation();
            }
            this.isVisible = !this.isVisible;
        },
        close: function () {
            this.isVisible = false;
        },
        buttonClick: function (event, action) {
            if (event) {
                event.stopPropagation();
            }

            // Function can access action information using 'this'
            action.event(this.row, action.params);
        }
    }
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';

.actions {
    ul {
        // position: absolute;
        top: 0;
        right: 20px;
        z-index: 1;

        > li:hover {
            color: $dark;
        }
    }
}
</style>



// WEBPACK FOOTER //
// baseActions.vue?09acba30